<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-12 17:38:35
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-23 15:51:33
-->
<template>
  <div class="content">
    <div class="top-info">
      <span class="cell number">
        <i
          class="iconfont icon-dingdanbianhao"
          style="font-size: 20px; margin-right: 5px"
        ></i>
        订单编号：{{ detail.orderNum }}
      </span>
      <span class="cell">委托方：{{ detail.client }}</span>
      <span class="cell">订单类型：{{ detail.orderTypeName }}</span>
    </div>
    <el-table
      class="table-machine-info"
      :data="info"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="cropName"
        label="种植作物"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="workTypeName"
        label="作业类型"
        min-width="18%"
        align="center"
        :resizable="false"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        label="作业时间要求"
        min-width="22%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="trusteeshipNum"
        label="托管地块"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="workFinishNum"
        label="已作业地块"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="noAuditNum"
        label="待监督地块"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="auditPassNum"
        label="合格地块"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="auditFailNum"
        label="不合格地块"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "DetailTopPart",
  data() {
    return {
      detail: {},
      info: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  mounted() {
    this.getOrderDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderDetail() {
      this.$http.village.getOrderDetail({ id: this.orderId }).then((res) => {
        this.detail = res.data;
        this.info = [res.data];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .top-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    color: #018388;
    .cell {
      display: flex;
      align-items: center;
      margin-right: 4%;
      &.number {
        font-weight: 900;
      }
    }
  }
  ::v-deep .el-table {
    &.table-machine-info {
      margin-top: 20px;
    }
    thead {
      color: #5f6868;
      .el-table__cell {
        font-weight: normal;
        background-color: #f1f5f8;
      }
    }
  }
}
</style>
